import { observer } from 'mobx-react-lite';
import React from 'react';
import { colors } from '../../../../../../../../colorVars';
import CheckBox from '../../../../../../../atomic/formElements/checkBox/CheckBox';
import { Body2, fontSizes } from '../../../../../../../atomic/text/Text';
import { useAlertFormStore } from '../../alertFormClass';
import style from './DeactivateField.module.css';

export const DeactivateField = observer(() => {
  const form = useAlertFormStore();
  if (!form.restartSystemOncePositionHasFlattened) return null;

  return (
    <div className={style.container}>
      <Body2 color={colors.lightGrey} fontWeight={700}>
        Deactivate on Restart
      </Body2>
      <div className={style.checkboxes}>
        <CheckBox
          fontSize={fontSizes.body2}
          color={colors.lightGrey}
          checked={form.restartSettings.deactivateOnRestart}
          onChange={(value) => form.setDeactivateOnRestart(value)}
        />
      </div>
    </div>
  );
});
